// extracted by mini-css-extract-plugin
export var columnItem = "_cg-3";
export var columnItemDraggable = "_cg-4";
export var dragHandle = "_cg-0";
export var dragHandleHovered = "_cg-1";
export var dropdown = "_cg-5";
export var dropdownContent = "_cg-7";
export var dropdownInner = "_cg-6";
export var filterDropdownHeader = "_cg-8";
export var icon = "_cg-2";
export var sectionDivider = "_cg-9";